/**
 * 
 * @param props 
 * @returns JSX.Element
 * 
 *  This is path takes a sorted array items that have a timestamp and a value.  This path loops through the data 
 *  and gets the xy value of each item and draws a line from point to point.
 *  
 *  Sample Data:
 *  [{ timestamp: '2026-01-01T00:00:00Z', value: 10}, {timestamp: '2026-01-02T00:00:00Z', value: 20}, {timestamp: '2026-01-03T00:00:00Z', value: 15}]
 * 
 */

import { generateD3Path } from "../util/generateD3Path"


export const InlinePath = (props: Record<string, unknown>): JSX.Element => {
    
      const {
        data,
        axis_settings,
        colors,
        color
      } = props
    
      const line_type = 'default'
    
      props = {...props, line_type}
    
 
    
      const d3paths = []
    
      const scale_y = axis_settings?.left || axis_settings?.right
      const scale_x = axis_settings?.bottom || axis_settings?.top

      const keys = scale_x?.keys || scale_y?.keys
      
      if (keys) {
        keys.forEach((key: string) =>  d3paths.push({
          d: generateD3Path({...props, scale_y, scale_x, y_key: key}, data),
          group: key,
          y_key: key,
          x_key: scale_x?.key,
          color: color || colors?.[key]
        }))
      } else {
        d3paths.push({
          d: generateD3Path({...props, scale_y, scale_x }, data),
          group: scale_y?.key,
          y_key: scale_y?.key,
          x_key: scale_x?.key,
          color: color || scale_y?.color || colors?.[scale_y?.key]
        })
      }
      
      return (
        <>
          {d3paths.map((path, index) => (
            <path className='configured-path configured-path--inline-path' key={index} data-id='path' data-path={path?.group} data-group={path?.group} d={path.d} fill='none' stroke={path.color} strokeWidth={1} />
          ))}
        </>
      )
 
}

export default InlinePath